import { render, staticRenderFns } from "./VehicleTypeList.vue?vue&type=template&id=582a6ca8"
import script from "./VehicleTypeList.vue?vue&type=script&lang=js"
export * from "./VehicleTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports